import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';

import { trackUpsellStage } from '../../../helpers/trackUpsell/trackUpsellStage';
import { PaymentContext } from '../PaymentContextProvider';
import BILLING_PROVIDERS from '../../../constants/billingProviders';

const useTrackUpsellStage = (paymentJourney = false) => {
  const { resolvedUpgradeOffer, isFlexFlow } = useContext(PaymentContext);
  const newProvider = useSelector(state => state.billing.billingProvider === BILLING_PROVIDERS.NEW);
  const upsellCorrelationId = useSelector(state => state.upsellProgress.upsellCorrelationId);
  const customerId = useSelector(state => state.auth.currentUser.customerId);
  const csrfToken = useSelector(state => state.auth.csrfToken);

  return useCallback(
    (upsellStage, errorInfo = null) => {
      if (isFlexFlow) return;
      if (!upsellCorrelationId && !paymentJourney) return;
      trackUpsellStage(
        upsellStage,
        customerId,
        upsellCorrelationId,
        csrfToken,
        resolvedUpgradeOffer.id,
        resolvedUpgradeOffer.family,
        newProvider,
        errorInfo
      );
    },
    [customerId, upsellCorrelationId, resolvedUpgradeOffer, newProvider, csrfToken, paymentJourney, isFlexFlow]
  );
};

export default useTrackUpsellStage;
